var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 7.50147C11.2484 7.82058 11.1758 8.13534 11.0374 8.42289C10.899 8.71045 10.6984 8.9636 10.45 9.16397L4.075 14.4265C3.69121 14.734 3.22875 14.9275 2.74034 14.9849C2.25192 15.0424 1.75718 14.9615 1.3125 14.7515C0.926033 14.5811 0.596767 14.3031 0.364028 13.9507C0.13129 13.5983 0.00491632 13.1863 0 12.764L0 2.23897C0.00491632 1.81665 0.13129 1.40467 0.364028 1.05224C0.596767 0.699809 0.926033 0.42182 1.3125 0.251471C1.75718 0.0414295 2.25192 -0.0394716 2.74034 0.0179892C3.22875 0.0754509 3.69121 0.268961 4.075 0.576468L10.45 5.83897C10.6984 6.03934 10.899 6.29249 11.0374 6.58005C11.1758 6.8676 11.2484 7.18236 11.25 7.50147Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarot);
export default __webpack_public_path__ + "static/media/carot.ead236755ae35ac5164fb76adf71ec30.svg";
export { ForwardRef as ReactComponent };